module.exports = __webpack_public_path__ + "static/media/geobike-desktop.71197398.png";